export default __webpack_public_path__ + "static/media/greeting8.a484c83e.png";